import React, { useState, useEffect } from 'react';
import './Config.css';
import { getConfigurationApi, createUpdateConfigurationApi, ImageUrl } from '../../helper/apiHelper';
import toast from 'react-hot-toast';

const ConfigLayer = () => {
  const [activeTab, setActiveTab] = useState('whatsapp');
  const [isLoading, setIsLoading] = useState(false);

  const [whatsappConfig, setWhatsappConfig] = useState({
    id: null,
    buttonText: '',
    buttonColor: '#25D366', // Default Whatsapp Color
    icon: null,
    iconPreview: null,
    whatsappNo: '',
    whatsappMessage: ''
  });

  const [fantuanConfig, setFantuanConfig] = useState({
    id: null,
    buttonText: '',
    buttonColor: '#3B5BA3', // Default color
    icon: null,
    iconPreview: null,
    redirectionLink: ''
  });

  // Fetch configuration when component mounts or tab changes
  useEffect(() => {
    const fetchConfig = async () => {
      setIsLoading(true);
      try {
        const configurationType = activeTab === 'whatsapp' ? 'WHATSAPP' : 'CUSTOM';
        const response = await getConfigurationApi(configurationType);

        if (response.data) {
          const data = response.data;

          if (activeTab === 'whatsapp') {
            setWhatsappConfig({
              id: data.id,
              buttonText: data.buttonText || '',
              buttonColor: data.buttonColor || '#25D366',
              icon: null,
              iconPreview: data.icon ? `${ImageUrl}/${data.icon}` : null,
              whatsappNo: data.whatsAppNumber || '',
              whatsappMessage: data.whatsAppMessage || ''
            });
          } else {
            setFantuanConfig({
              id: data.id,
              buttonText: data.buttonText || '',
              buttonColor: data.buttonColor || '#3B5BA3',
              icon: null,
              iconPreview: data.icon ? `${ImageUrl}/${data.icon}` : null,
              redirectionLink: ''
            });
          }
        }
      } catch (error) {
        // If no configuration exists yet, that's okay - user will create new one
        console.log('No existing configuration found or error:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchConfig();
  }, [activeTab]);

  const fetchConfiguration = async () => {
    setIsLoading(true);
    try {
      const configurationType = activeTab === 'whatsapp' ? 'WHATSAPP' : 'CUSTOM';
      const response = await getConfigurationApi(configurationType);

      if (response.data) {
        const data = response.data;

        if (activeTab === 'whatsapp') {
          setWhatsappConfig({
            id: data.id,
            buttonText: data.buttonText || '',
            buttonColor: data.buttonColor || '#25D366',
            icon: null,
            iconPreview: data.icon ? `${ImageUrl}/${data.icon}` : null,
            whatsappNo: data.whatsAppNumber || '',
            whatsappMessage: data.whatsAppMessage || ''
          });
        } else {
          setFantuanConfig({
            id: data.id,
            buttonText: data.buttonText || '',
            buttonColor: data.buttonColor || '#3B5BA3',
            icon: null,
            iconPreview: data.icon ? `${ImageUrl}/${data.icon}` : null,
            redirectionLink: ''
          });
        }
      }
    } catch (error) {
      // If no configuration exists yet, that's okay - user will create new one
      console.log('No existing configuration found or error:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleWhatsappChange = (e) => {
    const { name, value } = e.target;

    if (name === 'whatsappNo') {
      let filteredValue = value.replace(/\D/g, ''); // remove non-digits
      if (filteredValue.length > 10) {
        filteredValue = filteredValue.slice(0, 10);
      }
      setWhatsappConfig(prev => ({
        ...prev,
        [name]: filteredValue
      }));
    } else {
      setWhatsappConfig(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };


  const handleFantuanChange = (e) => {
    const { name, value } = e.target;
    setFantuanConfig(prev => ({ ...prev, [name]: value }));
  };

  const handleWhatsappIconChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setWhatsappConfig(prev => ({
        ...prev,
        icon: file,
        iconPreview: URL.createObjectURL(file)
      }));
    }
  };

  const handleFantuanIconChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFantuanConfig(prev => ({
        ...prev,
        icon: file,
        iconPreview: URL.createObjectURL(file)
      }));
    }
  };

  const handleWhatsappSave = async () => {
    // Validation
    if (!whatsappConfig.buttonText) {
      toast.error('Please enter button text');
      return;
    }
    if (!whatsappConfig.whatsappNo) {
      toast.error('Please enter WhatsApp number');
      return;
    }


    if (whatsappConfig.whatsappNo.length !== 10) {
      toast.error('WhatsApp number must be exactly 10 digits');
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();

      // Add id if updating existing config
      if (whatsappConfig.id) {
        formData.append('id', whatsappConfig.id);
      }

      formData.append('configurationType', 'WHATSAPP');
      formData.append('buttonText', whatsappConfig.buttonText);
      formData.append('buttonColor', whatsappConfig.buttonColor);
      formData.append('whatsAppNumber', whatsappConfig.whatsappNo);
      formData.append('whatsAppMessage', whatsappConfig.whatsappMessage);

      // Add icon if user selected a new one
      if (whatsappConfig.icon) {
        formData.append('icon', whatsappConfig.icon);
      }

      await createUpdateConfigurationApi(formData);
      toast.success('WhatsApp Configuration Saved!');

      // Refresh configuration data
      await fetchConfiguration();
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to save WhatsApp configuration');
    } finally {
      setIsLoading(false);
    }
  };

  const handleFantuanSave = async () => {
    // Validation - Button Text is required

    if (!fantuanConfig.buttonText) {
      toast.error('Please enter button text');
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();

      // Add id if updating existing config
      if (fantuanConfig.id) {
        formData.append('id', fantuanConfig.id);
      }

      formData.append('configurationType', 'CUSTOM');
      formData.append('buttonText', fantuanConfig.buttonText);
      formData.append('buttonColor', fantuanConfig.buttonColor);
      formData.append('whatsAppNumber', '');
      formData.append('whatsAppMessage', '');

      // Add icon if user selected a new one
      if (fantuanConfig.icon) {
        formData.append('icon', fantuanConfig.icon);
      }

      await createUpdateConfigurationApi(formData);
      toast.success('Custom Configuration Saved!');

      // Refresh configuration data
      await fetchConfiguration();
    } catch (error) {
      toast.error(error || 'Failed to save custom configuration');
    } finally {
      setIsLoading(false);
    }
  };

  const addVariable = () => {
    setWhatsappConfig(prev => ({
      ...prev,
      whatsappMessage: prev.whatsappMessage + ' {{product_name}} '
    }));
  };

  return (
    <div className="card h-100">
      <div className="card-header border-bottom bg-base py-16 px-24">
        <h6 className="text-lg fw-semibold mb-0">Configuration</h6>
      </div>

      <div className="card-body p-24">
        {/* Tabs Navigation */}
        <ul className="nav custom-tabs " role="tablist">
          <li className="nav-item">
            <button
              type="button"
              onClick={() => setActiveTab("whatsapp")}
              className={`nav-link ${activeTab === "whatsapp" ? "active" : ""
                }`}
            >
              WhatsApp
            </button>
          </li>

          <li className="nav-item">
            <button
              type="button"
              onClick={() => setActiveTab("fantuan")}
              className={`nav-link ${activeTab === "fantuan" ? "active" : ""
                }`}
            >
              Custom
            </button>
          </li>
        </ul>


        {/* Tab Content */}
        <div className="tab-content" id="pills-tabContent">

          {/* Whatsapp Tab */}
          {activeTab === 'whatsapp' && (
            <div className="tab-pane fade show active" role="tabpanel">
              <h6 className="mb-16">Whatsapp Configuration</h6>

              <div className="row gy-4">
                {/* Configuration Form */}
                <div className="col-lg-6">
                  <div className="row gy-3">
                    <div className="col-12">
                      <label className="form-label">Button Text</label>
                      <input
                        type="text"
                        name="buttonText"
                        className="form-control"
                        placeholder="e.g. Chat on Whatsapp"
                        value={whatsappConfig.buttonText}
                        onChange={handleWhatsappChange}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Button Color</label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="color"
                          name="buttonColor"
                          className="form-control form-control-color"
                          value={whatsappConfig.buttonColor}
                          onChange={handleWhatsappChange}
                          title="Choose your color"
                        />
                        <span>{whatsappConfig.buttonColor}</span>
                      </div>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Icon (Optional)</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleWhatsappIconChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Preview Section */}
                <div className="col-lg-6 d-flex align-items-center justify-content-center border rounded-3 bg-light-50">
                  <div className="text-center p-4">
                    <p className="mb-3 text-secondary">Button Preview</p>
                    <button
                      className="btn d-inline-flex align-items-center gap-2 text-white px-24 py-12  hover-scale"
                      style={{ backgroundColor: whatsappConfig.buttonColor, border: 'none' }}
                    >
                      {whatsappConfig.iconPreview && (
                        <img
                          src={whatsappConfig.iconPreview}
                          alt="icon"
                          style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                        />
                      )}
                      {whatsappConfig.buttonText || 'Button Text'}
                    </button>
                  </div>
                </div>

                <div className="col-12">
                  <hr />
                </div>

                <div className="col-12">
                  <label className="form-label">WhatsApp No</label>

                  <div className="input-group">
                    <span className="input-group-text">+1</span>
                    <input
                      type="text"
                      name="whatsappNo"
                      className="form-control"
                      placeholder="1234567890"
                      value={whatsappConfig.whatsappNo}
                      onChange={handleWhatsappChange}
                      maxLength={10}
                    />
                  </div>

                  <small className="text-muted">
                    Enter 10-digit WhatsApp number
                  </small>
                </div>


                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label mb-0">Whatsapp Message</label>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary py-1 px-2"
                      onClick={addVariable}
                    >
                      + Add Product Name
                    </button>
                  </div>
                  <textarea
                    name="whatsappMessage"
                    className="form-control"
                    rows="3"
                    placeholder="Hello, I am interested in..."
                    value={whatsappConfig.whatsappMessage}
                    onChange={handleWhatsappChange}
                  ></textarea>
                </div>

                <div className="col-12 text-end">
                  <button
                    type="button"
                    className="btn btn-primary-600"
                    onClick={handleWhatsappSave}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Saving...' : 'SAVE'}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Fantuan Tab */}
          {activeTab === 'fantuan' && (
            <div className="tab-pane fade show active" role="tabpanel">
              <h6 className="mb-16">Custom Configuration</h6>

              <div className="row gy-4">
                {/* Configuration Form */}
                <div className="col-lg-6">
                  <div className="row gy-3">
                    <div className="col-12">
                      <label className="form-label">Button Text</label>
                      <input
                        type="text"
                        name="buttonText"
                        className="form-control"
                        placeholder="e.g. Order on Fantuan"
                        value={fantuanConfig.buttonText}
                        onChange={handleFantuanChange}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label">Button Color</label>
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="color"
                          name="buttonColor"
                          className="form-control form-control-color"
                          value={fantuanConfig.buttonColor}
                          onChange={handleFantuanChange}
                          title="Choose your color"
                        />
                        <span>{fantuanConfig.buttonColor}</span>
                      </div>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Icon (Optional)</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFantuanIconChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Preview Section */}
                <div className="col-lg-6 d-flex align-items-center justify-content-center border rounded-3 bg-light-50">
                  <div className="text-center p-4">
                    <p className="mb-3 text-secondary">Button Preview</p>
                    <button
                      className="btn d-inline-flex align-items-center gap-2 text-white px-24 py-12  hover-scale"
                      style={{ backgroundColor: fantuanConfig.buttonColor, border: 'none' }}
                    >
                      {fantuanConfig.iconPreview && (
                        <img
                          src={fantuanConfig.iconPreview}
                          alt="icon"
                          style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                        />
                      )}
                      {fantuanConfig.buttonText || 'Button Text'}
                    </button>
                  </div>
                </div>

                {/* <div className="col-12">
                  <hr />
                </div> */}

                {/* <div className="col-12">
                  <label className="form-label">Redirection Link</label>
                  <input
                    type="url"
                    name="redirectionLink"
                    className="form-control"
                    placeholder="https://..."
                    value={fantuanConfig.redirectionLink}
                    onChange={handleFantuanChange}
                  />
                </div> */}

                <div className="col-12 text-end">
                  <button
                    type="button"
                    className="btn btn-primary-600"
                    onClick={handleFantuanSave}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Saving...' : 'SAVE'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigLayer;
